import React from 'react';
import { useLocation } from 'react-router-dom';

//estilos
import '../assets/css/base.css'

const Footer = () => {
    const location = useLocation();
    const date= new Date();

    // el sistema contable tiene su propio footer
    if (location.pathname.startsWith("/sistema-contable")) {
        return null;
    }

    return (
        <footer >
            Derechos Reservados  BIGDATA C.A. &copy; {date.getFullYear()}
        </footer>
    );
}

export default Footer;